import "../../form/field_counter.js";

window.SEOFieldsManager = window.SEOFieldsManager || {}; // VITE_MIGRATION: ensure namespace exists before submodule assignment
window.SEOFieldsManager.SnippetModal = class SnippetModal {
  constructor(options) {
    this.render = this.render.bind(this);
    this.setOptions = this.setOptions.bind(this);
    this.show = this.show.bind(this);
    this._buildFields = this._buildFields.bind(this);
    this._updateCounters = this._updateCounters.bind(this);
    this._addCounters = this._addCounters.bind(this);
    this._addCounter = this._addCounter.bind(this);
    this._removeCounters = this._removeCounters.bind(this);
    this._updateDescriptionCounterVisibility = this._updateDescriptionCounterVisibility.bind(this);
    this._proxyEvent = this._proxyEvent.bind(this);
    this.options = jQuery.extend(true, { targets: {}, thresholds: {} }, options);
    this.fields = this._buildFields();
    this.titleInput = this.fields.find('[data-behaviour="title-input"]');
    this.descriptionInput = this.fields.find('[data-behaviour="description-input"]');

    this.modal = new WizardModal({ class: "admin-modal", id: "snippet-modal" });
    this.page = this.modal.addPage({});
    this.counters = [];

    // BEHAVIOUR

    jQuery(this.modal.container).on("complete cancel", this._proxyEvent);
  }

  render() {
    this.page.setHeader(this.options.header);
    this.page.setBody(this.fields);
    this._addCounters();

    if (this.descriptionInput.data("default-placeholder")) {
      this.descriptionInput.attr("placeholder", this.descriptionInput.data("default-placeholder"));
      this._updateDescriptionCounterVisibility();
    }

    return this;
  }

  // HELPER FUNCTIONS

  setOptions(options) {
    jQuery.extend(true, this.options, options);
    if (this.modal.isShowing()) {
      return this.render();
    }
  }

  show() {
    this.render();
    return this.modal.show();
  }

  // PRIVATE

  _buildFields() {
    return jQuery('<div class="definition-list">').append(window.SparkleConfig.adminHtml.seoSnippetFields);
  }

  _updateCounters() {
    return this.counters.forEach((counter) => counter.render());
  }

  _addCounters() {
    this._removeCounters();
    this._addCounter(this.titleInput, this.options.targets.title, this.options.thresholds.title);
    this._addCounter(this.descriptionInput, this.options.targets.description, this.options.thresholds.description);
    return jQuery(this.descriptionInput).on("input change", this._updateDescriptionCounterVisibility);
  }

  _addCounter(input, target, threshold) {
    const counter = new Form.FieldCounter(input, { target, threshold, counter: this._fieldLength }).render();
    counter.el.appendTo(input.closest(".field").find(".field-label"));
    return this.counters.push(counter);
  }

  _removeCounters() {
    this.counters.forEach((counter) => counter.el.remove());
    return this.counters.slice(0);
  }

  _fieldLength(input) {
    return jQuery.trim(input.val()).length || jQuery.trim(input.attr("placeholder")).length;
  }

  _updateDescriptionCounterVisibility() {
    if (!this.counters.length) {
      return;
    }

    if (this.descriptionInput.val().length) {
      return this.descriptionInput.data("fieldCounter").el.show();
    } else if (this.descriptionInput.data("default-placeholder")) {
      return this.descriptionInput.data("fieldCounter").el.hide();
    }
  }

  _proxyEvent(event, ...args) {
    return jQuery(this).triggerHandler(event, ...Array.from(args));
  }
};
